import React, { useEffect, useState } from 'react';
import { mainApiService } from '../services/apiService';
import { endpoints } from '../config/endpoints';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface TrialStatus {
  in_trial: boolean;
  days_remaining: number;
  trial_ends_at: string | null;
}

interface Props {
  onUpgrade?: () => void;
}

export default function TrialBanner({ onUpgrade }: Props) {
  const [status, setStatus] = useState<TrialStatus | null>(null);
  const [dismissed, setDismissed] = useState(() =>
    sessionStorage.getItem('trialBannerDismissed') === '1'
  );

  useEffect(() => {
    mainApiService.get<TrialStatus>(endpoints.main.billing.trialStatus)
      .then(res => { if (res.success && res.data) setStatus(res.data); })
      .catch(() => {});
  }, []);

  if (!status?.in_trial || dismissed) return null;

  const days = status.days_remaining;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9998,
      background: days <= 3 ? '#7c2d12' : '#1e1b4b',
      borderBottom: `1px solid ${days <= 3 ? '#c2410c' : '#4c1d95'}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '10px 16px', gap: '16px',
    }}>
      <span style={{ color: '#e5e7eb', fontSize: '14px' }}>
        {days <= 1
          ? 'Your free trial ends today.'
          : `You have ${days} day${days !== 1 ? 's' : ''} left in your free trial.`}
      </span>
      {onUpgrade && (
        <button
          onClick={onUpgrade}
          style={{
            padding: '4px 14px', fontSize: '13px', fontWeight: 600,
            background: '#6d28d9', color: '#fff', border: 'none',
            borderRadius: '6px', cursor: 'pointer',
          }}
        >
          Upgrade now
        </button>
      )}
      <button
        onClick={() => { sessionStorage.setItem('trialBannerDismissed', '1'); setDismissed(true); }}
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: '2px' }}
        aria-label="Dismiss"
      >
        <XMarkIcon style={{ width: 16, height: 16 }} />
      </button>
    </div>
  );
}
